import { useEffect, useMemo, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const ComingSoon = () => {
    const getTomorrowAt = (h = 12, m = 0, s = 0) => {
        const now = new Date();
        const t = new Date(now);
        t.setDate(now.getDate() + 1);
        t.setHours(h, m, s, 0);
        return t;
    };

    const CSA_TARGET = useMemo(() => getTomorrowAt(12, 0, 0), []);
    const HK_TARGET = useMemo(() => getTomorrowAt(14, 0, 0), []);

    const [csaLeft, setCsaLeft] = useState(CSA_TARGET - new Date());
    const [hkLeft, setHkLeft] = useState(HK_TARGET - new Date());

    useEffect(() => {
        const id = setInterval(() => {
            setCsaLeft(CSA_TARGET - new Date());
            setHkLeft(HK_TARGET - new Date());
        }, 1000);
        return () => clearInterval(id);
    }, [CSA_TARGET, HK_TARGET]);

    const fmt = (ms) => {
        if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0 };
        const total = Math.floor(ms / 1000);
        const d = Math.floor(total / 86400);
        const h = Math.floor((total % 86400) / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        return { d, h, m, s };
    };

    const csa = fmt(csaLeft);
    const hk = fmt(hkLeft);

    return (
        <div className="min-vh-100 bg-light">
            {/* Header Section */}
            {/* <div className="bg-primary text-white py-4 text-center">
        <h1 className="fw-bold mb-1">Indian Airways</h1>
        <p className="mb-0">Examination Schedule</p>
      </div> */}

            <div className="container py-5">
                {/* Main Card */}
                <div className="card shadow-sm border-0">
                    <div className="card-body text-center">
                        <img src="/assets/img/logo/AviationLogo-08.png" alt="" height={100} width={100} />
                        <h3 className="fw-bold text-primary">Coming Soon</h3>
                        <p className="lead mb-4">Exams start <strong>tomorrow</strong></p>
                        <p className="fw-bold">Exam Duration: 90 Minutes</p>
                    </div>
                </div>

                {/* Schedule Row */}
                <div className="row mt-4">
                    {/* CSA */}
                    <div className="col-md-6 mb-3">
                        <div className="card h-100 border-0 shadow-sm px-5 py-3">
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="fw-bold mb-0">CSA</h5>
                                    <span className="badge bg-success">12:00 PM – 1:30 PM</span>
                                </div>
                                <br/>

                                <div className="d-flex justify-content-between my-3">
                                    <TimeBlock label="Days" value={csa.d} />
                                    <TimeBlock label="Hours" value={csa.h} />
                                    <TimeBlock label="Minutes" value={csa.m} />
                                    <TimeBlock label="Seconds" value={csa.s} />
                                </div><br/>
                                <a href="https://indianairways.net/" className="btn btn-outline-primary btn-sm me-2">Visit our website</a>
                                <a href="https://indianairways.net/contactus" className="btn btn-primary btn-sm">Contact</a>
                            </div>
                        </div>
                    </div>

                    {/* Housekeeping */}
                    <div className="col-md-6 mb-3">
                        <div className="card h-100 border-0 shadow-sm  px-5 py-3">
                            <div className="card-body text-center">
                                 <div className="d-flex justify-content-between align-items-center"><h5 className="fw-bold">Housekeeping / Loader</h5>
                                <span className="badge bg-info mb-2">2:00 PM – 3:30 PM</span></div>
                                <br />
                                <div className="d-flex justify-content-between my-3">
                                    <TimeBlock label="Days" value={hk.d} />
                                    <TimeBlock label="Hours" value={hk.h} />
                                    <TimeBlock label="Minutes" value={hk.m} />
                                    <TimeBlock label="Seconds" value={hk.s} />
                                </div><br/>
                                <a href="https://indianairways.net/" className="btn btn-outline-primary btn-sm me-2">Visit our website</a>
                                <a href="https://indianairways.net/contactus" className="btn btn-primary btn-sm">Contact</a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center mt-4 text-muted small">
                    Need help? Email <strong>support@indianairways.net</strong> or use the Contact page.
                </div>
            </div>
        </div>
    );
};

function TimeBlock({ label, value }) {
    return (
        <div>
            <div className="medium text-muted bold">{String(value).padStart(2, "0")}</div>
            <div className="medium text-muted">{label}</div>
        </div>
    );
}

export default ComingSoon;
